import styled from 'styled-components';

const BoxTitle = styled.h3`
  font-size: 14px;
  font-weight: 500;
  color: #323332;
  margin: 0;
  margin-bottom: 5px;
`;

const BoxSubTitle = styled.p`
  font-size: 13px;
  font-weight: 400;
  color: #797979;
  line-height: 24px;
`;

export { BoxTitle, BoxSubTitle };



// WEBPACK FOOTER //
// ./src/components/UI/styles/boxTitle.style.js